import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import {
    selectHasMembersSummarizationPermission,
    selectHasSummarizationBanRolePermission,
    setSummarizationForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { selectIsSummarizationAvailable } from '../../../../../../pages/call/features/summarization';
import { Switch } from '../../../../../components';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../features/flags/selectors';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import styles from './styles.css';

export const SummarizationSwitcher: FunctionComponent = () => {
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const hasBanPermission = useSelector(selectHasSummarizationBanRolePermission);
    const hasMembersPermission = useSelector(selectHasMembersSummarizationPermission);

    const onChange = useOnPermissionChange(setSummarizationForMembersAllowed, 'summarization_manage_for_participants');
    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    if (!isSummarizationAvailable || !hasBanPermission) {
        return null;
    }

    return (
        <Switch
            className={styles.switch}
            labelAfter={
                calendarSummarizationFeatureEnabled
                    ? i18n('settings-v2', 'role-permission-summarization')
                    : i18n('settings-v2', 'permission-ban-summarization-v2')
            }
            checked={hasMembersPermission}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
